import Vue from 'vue'
import router from './router'

// import NProgress from 'nprogress'//进度条
// import 'nprogress/nprogress.css'
// NProgress.configure({
// 	easing: 'ease',  // 动画方式
// 	speed: 500,  // 递增进度条的速度
// 	showSpinner: false, // 是否显示加载ico
// 	trickleSpeed: 200, // 自动递增间隔
// 	minimum: 0.3 ,// 初始化时的最小百分比
// })
const whiteList = ['/login', '/regist', '/regist_org', '/resetPwd', '/agreement'] //当前路由不需要验证token
// 当路由进入前
router.beforeEach((to, from, next) => {
  //获取用户token
  const hasToken = localStorage.getItem('userInfo')
  if (hasToken) {
    next()
  } else {
    //当前用户没有token
    console.log(to.path);
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login`)
    }
  }
});


//拦截器设置全局请求token
Vue.http.interceptors.push((request, next) => {
  if (localStorage.getItem('userInfo') != "null" && localStorage.getItem('userInfo') != "" && localStorage.getItem('userInfo') != null) {
    request.headers.set('Authorization', JSON.parse(localStorage.getItem('userInfo')).token); //设置请求头
    // request.headers.set('Content-Type','application/json;charset=UTF-8'); //设置请求头
  }
  request.headers.set('us', 'web'); //设置web后台标识
  request.headers.set('yxVersion', '2.10'); //rsa加密版本
  //设置请求时间
  let timeout;
  // 如果某个请求设置了_timeout,那么超过该时间，会终端该（abort）请求,并执行请求设置的钩子函数onTimeout方法，不会执行then方法。
  if (request._timeout) {
    timeout = setTimeout(() => {
      if (request.onTimeout) {
        request.onTimeout(request);
        request.abort()
      }
    }, request._timeout);
  }
  next((response) => {
    clearTimeout(timeout);
    return response
  })
})



// WEBPACK FOOTER //
// ./src/permission.js